"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return getBufferFromPath;
    }
});
async function getBufferFromPath(src = "") {
    if (!src) return;
    try {
        const response = await fetch(src);
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        const buffer = await response.arrayBuffer();
        return buffer;
    } catch (error) {
        console.error("Error fetching file:", error);
        return null;
    }
}
